// extracted by mini-css-extract-plugin
export var info = "Employee-module--info--P26qs";
export var root = "Employee-module--root--SljAK";
export var title = "Employee-module--title--aLRod";
export var url = "Employee-module--url--bx2EA";